export default "__VITE_ASSET__4zvAwhki__"